<div class="sd-shell" *ngIf="!loader; else loadingTpl">
  <div class="sd-header-area">
    <div class="sd-title-wrap">
      <div>
        <h1>Sales Dashboard</h1>
      </div>
    </div>
    <div class="sd-header-actions">

      <p-dropdown [options]="warehouseList" [(ngModel)]="selectedWarehouse" optionLabel="warehouseName"
        (onChange)="onWarehouseChange($event)" placeholder="Select Warehouse" styleClass="sd-filter-dropdown">
      
        <ng-template let-item pTemplate="item">
          <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
        </ng-template>
      
      </p-dropdown>
      <div class="sd-date-chip">
        <i class="pi pi-calendar"></i>
        {{ todayDate }}
      </div>
      <div class="sd-filter-wrap">
        <label for="periodSelect" class="sd-filter-label">Period:</label>
        <select id="periodSelect" class="sd-filter-select" [(ngModel)]="selectedPeriod" (change)="onPeriodChange()">
          <option *ngFor="let option of periodOptions" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>
      <button class="sd-btn sd-btn-primary" (click)="refreshData()">
        <i class="pi pi-sync"></i> Refresh
      </button>
    </div>
  </div>

  <div class="sd-kpi-row sd-anim-fadeUp">

    <div class="sd-kpi-card sd-kpi-purple">
      <span class="sd-kpi-label">Gross Revenue</span>
      <div class="sd-kpi-val" id="kRev">0</div>
      <span class="sd-kpi-foot">
        <span [style.color]="revenueGrowth >= 0 ? '#4ade80' : '#f87171'">
          <i class="pi" [ngClass]="revenueGrowth >= 0 ? 'pi-arrow-up' : 'pi-arrow-down'"></i>
          {{ revenueGrowth | number:'1.1-1' }}%
        </span> vs last month
      </span>
      <i class="pi pi-indian-rupee sd-kpi-icon"></i>
    </div>

    <div class="sd-kpi-card sd-kpi-blue">
      <span class="sd-kpi-label">Total Sales</span>
      <div class="sd-kpi-val" id="kOrd">0</div>
      <span class="sd-kpi-foot">Avg: {{ avgOrderValue }} per order</span>
      <i class="pi pi-shopping-bag sd-kpi-icon"></i>
    </div>

    <div class="sd-kpi-card sd-kpi-teal">
      <span class="sd-kpi-label">Invoiced</span>
      <div class="sd-kpi-val" id="kInv">0</div>
      <span class="sd-kpi-foot"><span style="color:#fcd34d;">{{ pendingOrders }} pending</span> orders</span>
      <i class="pi pi-check-circle sd-kpi-icon"></i>
    </div>

    <div class="sd-kpi-card sd-kpi-rose">
      <span class="sd-kpi-label">Customers</span>
      <div class="sd-kpi-val" id="kCus">0</div>
      <span class="sd-kpi-foot">{{ totalProductsSold || 0 }} products sold</span>
      <i class="pi pi-users sd-kpi-icon"></i>
    </div>

  </div>

  <div class="sd-main-grid">

    <div class="sd-col sd-col-left">

      <div class="sd-card sd-anim-fadeLeft" style="flex:1; min-height:0;">
        <div class="sd-card-header">
          <div class="sd-card-title-wrap">
            <span class="sd-card-title">Revenue Trend</span>
            <span class="sd-card-badge">Monthly</span>
          </div>
          <div class="sd-chart-legend">
            <span class="sd-leg-dot" style="background:#7c3aed"></span><span>Revenue</span>
          </div>
        </div>
        <div class="sd-chart-area">
          <p-chart type="line" [data]="trendChartData" [options]="trendChartOptions" height="100%"></p-chart>
        </div>
      </div>

      <div class="sd-bottom-row">

        <div class="sd-card sd-anim-fadeUp" style="flex:1.2; min-height:0;">
          <div class="sd-card-header">
            <span class="sd-card-title">Top Products</span>
            <span class="sd-card-badge">By Revenue</span>
          </div>
          <div class="sd-prod-list">
            <div class="sd-prod-item" *ngFor="let p of topProducts; let i = index"
              [style.animation-delay]="(i * 0.06) + 's'">
              <div class="sd-prod-rank" [style.background]="prodColors[i % 6] + '20'" [style.color]="prodColors[i % 6]">
                {{ i + 1 }}
              </div>
              <div class="sd-prod-info">
                <div class="sd-prod-name">{{ p.name }}</div>
                <div class="sd-prod-bar-wrap">
                  <div class="sd-prod-bar-fill" [style.width]="p.pct + '%'" [style.background]="prodColors[i % 6]">
                  </div>
                </div>
              </div>
              <div class="sd-prod-val">{{ p.revenue }}</div>
            </div>
          </div>
        </div>

        <div class="sd-card sd-anim-fadeUp" style="flex:0.9; min-height:0;">
          <div class="sd-card-header">
            <span class="sd-card-title">Workflow</span>
            <span class="sd-card-badge">Status</span>
          </div>
          <div class="sd-workflow-content">
            <div class="sd-stack-bar">
              <div class="sd-stack-seg" *ngFor="let s of data?.salesStatus"
                [style.width]="(s.totalRevenue / ((data?.keyMetrics?.totalRevenue)||1) * 100) + '%'"
                [style.background]="getStatusColor(s.status)" [pTooltip]="s.status + ': ' + s.formattedRevenue"
                tooltipPosition="top">
              </div>
            </div>
            <div class="sd-status-list">
              <div class="sd-status-item" *ngFor="let s of data?.salesStatus">
                <div class="sd-status-dot-wrap">
                  <span class="sd-status-dot" [style.background]="getStatusColor(s.status)"></span>
                </div>
                <div class="sd-status-info">
                  <span class="sd-status-name">{{ s.status }}</span>
                  <span class="sd-status-count">{{ s.orderCount }} orders</span>
                </div>
                <div class="sd-status-amount">{{ s.formattedRevenue }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="sd-col sd-col-right">

      <div class="sd-card sd-gst-card sd-anim-fadeRight">
        <div class="sd-card-header">
          <span class="sd-card-title">Tax & GST Distribution</span>
          <span class="sd-card-badge">Breakdown</span>
        </div>
        <div class="sd-gst-body">
          <div class="sd-gst-stats">
            <div class="sd-gst-item sd-gst-cgst">
              <span class="sd-gst-label">CGST</span>
              <span class="sd-gst-val">{{ formatINR(gstInfo?.totalCGST || 0) }}</span>
              <span class="sd-gst-count">{{ gstInfo?.cgstTransactions || 0 }} txns</span>
            </div>
            <div class="sd-gst-item sd-gst-sgst">
              <span class="sd-gst-label">SGST</span>
              <span class="sd-gst-val">{{ formatINR(gstInfo?.totalSGST || 0) }}</span>
              <span class="sd-gst-count">{{ gstInfo?.sgstTransactions || 0 }} txns</span>
            </div>
            <div class="sd-gst-item sd-gst-igst">
              <span class="sd-gst-label">IGST</span>
              <span class="sd-gst-val">{{ formatINR(gstInfo?.totalIGST || 0) }}</span>
              <span class="sd-gst-count">{{ gstInfo?.igstTransactions || 0 }} txns</span>
            </div>
          </div>
          <div class="sd-gst-chart">
            <p-chart type="doughnut" [data]="supplyChartData" [options]="supplyChartOptions" height="100%"></p-chart>
          </div>
        </div>
      </div>

      <div class="sd-card sd-anim-fadeRight">
        <div class="sd-card-header">
          <span class="sd-card-title">Supply Distribution</span>
          <span class="sd-card-badge">By Type</span>
        </div>
        <div class="sd-chart-area" style="height:160px;">
          <p-chart type="bar" [data]="supplyBarChartData" [options]="supplyBarChartOptions" height="100%"></p-chart>
        </div>
      </div>

      <div class="sd-card sd-table-card sd-anim-fadeRight">
        <div class="sd-card-header">
          <span class="sd-card-title">Recent Sales Orders</span>
          <span class="sd-card-badge sd-badge-live">{{ recentOrdersList.length || 0 }} entries</span>
        </div>
        <div class="sd-table-wrap">
          <table class="sd-table">
            <thead>
              <tr>
                <th>Order</th>
                <th>Customer</th>
                <th>Date</th>
                <th>Value</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let o of recentOrdersList; let i = index" class="sd-tr-anim"
                [style.animation-delay]="(i * 0.04) + 's'">
                <td><span>{{ o.salesOrderNumber }}</span></td>
                <td>
                  <div class="sd-client-cell">
                    <div class="sd-avatar" [style.background]="avatarColors[i % 6]">{{ o.initials }}</div>
                    <span class="sd-client-name">{{ o.customerName }}</span>
                  </div>
                </td>
                <td class="sd-date-cell">{{ o.date }}</td>
                <td class="sd-val-cell">{{ o.total }}</td>
                <td>
                  <span class="sd-status-pill" [ngClass]="'pill-' + o.statusClass">
                    {{ o.status }}
                  </span>
                </td>
              </tr>
              <tr *ngIf="!recentOrdersList.length">
                <td colspan="5" class="sd-empty">No order history available.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #loadingTpl>
  <div class="sd-loader">
    <div class="sd-loader-ring"></div>
    <p class="sd-loader-text">Compiling Analytics...</p>
  </div>
</ng-template>